import {Component, OnInit} from '@angular/core';
import {ApiService} from './services/api.service';
import {User} from './model/user';
import {ErrorHelper} from './common/ErrorHelper';
import {NotifierService} from 'angular-notifier';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  user: Promise<User> = null;

  constructor(
    private apiService: ApiService,
    private notifierService: NotifierService,
  ) {
  }

  ngOnInit(): void {
    this.getUserData().then(user => console.log(`Credentials loaded for ${user.username}`));
  }

  getUserData(): Promise<User> {
    if (this.user === null) {
      this.user = this.apiService.getCredentials().toPromise().then(user => {
        // this is necessary, because we do not really get a User object
        const newUser = new User();
        newUser.username = user.username;
        newUser.roles = user.roles;
        return newUser;
      }, error => {
        const errorMessage = ErrorHelper.disectError('get credentials', error);
        this.notifierService.notify('error', errorMessage);
        return new User();
      });
    }
    return this.user;
  }
}
